import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { formatDate } from '../../../../../utils'; 

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '20%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '20%',
    padding: 5,
    textAlign: 'center'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const ZeroStockProductPdfReport = ({ data }) => {

    const groupedData = data.reduce((acc, curr) => {
      const key = `${curr.product}-${curr.batch_no}-${curr.exp_date}`;  
      if (acc[key]) {
        acc[key].total_qty += curr.total_qty;
      } else {
        acc[key] = { ...curr };
      }
      return acc;
    }, {});
  const sortedData = Object.values(groupedData).sort((a, b) => {
    if (a.product_name < b.product_name) return -1;
    if (a.product_name > b.product_name) return 1;
    return 0;
  });


  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Zero Stock Product Pdf">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={styles.columnHeader} content="Sr" />
              <Text style={styles.columnHeader} content="Product Name" />
              <Text style={styles.columnHeader} content="Quantity" />
              <Text style={styles.columnHeader} content="Batch" />
              <Text style={styles.columnHeader} content="Expiry Date" />
            </View>
            {sortedData.map((item, index) => (
              <View
                key={index}
                style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}
              >
                <Text style={styles.columnContent} content={index + 1} />
                <Text style={styles.columnContent} content={item.product_name} />
                <Text style={styles.columnContent} content={item.total_qty} />
                <Text style={styles.columnContent} content={item._id.batch_no} />
                <Text style={styles.columnContent} content={formatDate(item.exp_date)} />
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};


